import { current } from "@reduxjs/toolkit";
import React, { useEffect, useState } from "react";

const data = [
  {
    headingName: "Location Type",
    option: [
      { btnText: "Bar/Restaurant", value: "Bar" },
      { btnText: "Store", value: "Store" },
      { btnText: "Online Store", value: "onlineStore" },
    ],
  },
];

const MobileFilterModal = (props: any) => {
  const {
    setCurrentCategory,
    currentCategory,
    setCurrentBrand,
    setShowMobileFilter,
    showMobileFilter,
    setShowOnlineStore,
    country,
    onlineStores,
    barDataExists,
    storeDataExists,
  } = props;
  const [category, setCategory] = useState(null);
  const handleClearFilters = () => {
    setCategory(null);
    setCurrentCategory(null);
  };

  useEffect(() => {
    setCategory(category);
  }, [currentCategory]);

  const categoryClass = (value: any) => {
    if (value === "Bar" && !barDataExists) {
      return "d-none";
    }
    if (value === "Store" && !storeDataExists) {
      return "d-none";
    }
    if (value === "onlineStore" && onlineStores?.length === 0) {
      return "d-none";
    }
    if (value === currentCategory) {
      return "common-btn active";
    } else {
      return "common-btn";
    }
  };

  return (
    <div className="mobile-filter-container">
      {/* <div className="clearFilter-text" onClick={handleClearFilters}>
        Clear Filters
      </div> */}
      <div className="filter-inner-wrapper mt-4">
        {data &&
          data?.length > 0 &&
          data?.map((item: any, index: any) => {
            return (
              <div className="location-type" key={index}>
                <h3 className="heading">{item?.headingName}</h3>
                <div className="btn-wrapper">
                  {item?.option &&
                    item?.option?.map((element: any, index: any) => {
                      return (
                        <button
                          key={index}
                          className={categoryClass(element?.value)}
                          onClick={() => {
                            setCurrentCategory(element?.value);
                            if (element?.value === "onlineStore") {
                              setShowOnlineStore(true);
                            } else {
                              setShowOnlineStore(false);
                            }
                          }}
                        >
                          {element?.btnText}
                        </button>
                      );
                    })}
                </div>
              </div>
            );
          })}
        {/* <div className="location-type">
          <h3 className="heading">Drink</h3>
          <div className="drink-btnwrapper">
            {props?.storeBrandsData &&
              props?.storeBrandsData.map((element: any, index: any) => {
                return (
                  <button
                    key={index}
                    className="drink-btn"
                    onClick={() => setBrand({label:element?.label,value:element?.label})}
                  >
                    {element?.label}
                  </button>
                );
              })}
          </div>
        </div> */}
      </div>
      <div className="lower-container text-right">
        {category && <span onClick={handleClearFilters}>Clear Filters</span>}
        <span onClick={() => setShowMobileFilter(!showMobileFilter)}>
          Close
        </span>
      </div>
    </div>
  );
};

export default MobileFilterModal;
